import Vue,{ createApp } from 'vue'
import 'element-plus/dist/index.css'
import App from './App.vue'
import store from './store'

const appInstance = createApp(App)
appInstance.use(store)
appInstance.mount("#mnv-chat-bubble")